import { render, staticRenderFns } from "./SmartRampStart.vue?vue&type=template&id=8ff7bc48"
import script from "./SmartRampStart.vue?vue&type=script&lang=js"
export * from "./SmartRampStart.vue?vue&type=script&lang=js"
import style0 from "./SmartRampStart.vue?vue&type=style&index=0&id=8ff7bc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports